import React from "react";
import { Card } from "antd";
import PageRoutes from "../../../utils/routes";
import { useNavigate } from "react-router-dom";

const CarouselJobItem = ({ job }) => {
  const navigate = useNavigate();
  const {
    firmUser: {
      firm: { companyName, imageUrl },
    },
    title,
    district,
    city,
    country,
    position: { name: positionName },
    sector: { name: sectorName },
    department: { name: departmentName },
    jobType: { description: jobType },
    durationType: { description: durationType },
    wageType: { description: wageType },
    wagePeriod: { description: wagePeriod },
    jobDescription,
    requiredQualification,
    personnelCount,
    startDate,
    endDate,
    minWage,
    maxWage,
    wage,
    minAge,
    maxAge,
    address,
    coordinate: { latitude: lat, longitude: long },
    currency,
    jobDuration,
    minEducationLevel,
    isExperienceRequired,
    experienceYear,
    keywords,
    options,
    isFavorite,
    isApplied,
    isAssigned,
    isCompleted,
    id,
    coverLetter,
  } = job;

  const location =
    district !== null
      ? `${district.name} / ${district.city.name}`
      : city !== null
      ? city.name
      : country.name;

  return (
    <div style={{ padding: "0 10px" }}>
      <button
        style={{
          border: "none",
          background: "none",
          padding: 5,
          width: "100%", // Make the button take full width
          cursor: "pointer",
        }}
        onClick={() => {
          navigate(`${PageRoutes.advertDetailEmployee}/${id}`);
        }}>
        <Card
          hoverable
          style={{
            height: "100%",
            backgroundColor: "#ffffff",
            borderRadius: "12px", // Increase corner radius
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", // Add subtle shadow
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between", // Spread content
            textAlign: "center",
          }}
          cover={
            <div
              style={{
                height: "150px", // Increased height to take larger portion of the card
                padding: "8px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}>
              <img
                alt={job.company}
                src={imageUrl}
                style={{
                  width: "80%", // Adjust the image width
                  height: "100%", // Ensure image fills the available height
                  objectFit: "contain", // Keep aspect ratio of the image
                }}
              />
            </div>
          }>
          <Card.Meta
            title={
              <div style={{ fontWeight: "bold", fontSize: "16px" }}>
                {title}
              </div>
            }
            description={
              <>
                <p style={{ marginBottom: 4 }}>{companyName}</p>
                <p style={{ color: "#888", fontSize: "14px" }}>{location}</p>
              </>
            }
          />
        </Card>
      </button>
    </div>
  );
};

export default CarouselJobItem;
